<template>
	<v-col cols="4">
		<v-card @click="$emit('click')" :dark="dark" :color="color">
			<!-- elevation="4" -->
			<v-list-item>
				<v-list-item-avatar>
					<v-icon>mdi-plus</v-icon>
				</v-list-item-avatar>
				<v-list-item-content>
					<v-list-item-title class="text-wrap" v-text="title" />
				</v-list-item-content>
			</v-list-item>
		</v-card>
	</v-col>
</template>

<script>
export default {
	props: {
		color: String,
		dark: Boolean,
		title: String,
	},
}
</script>